<template>
  <div>
    <!-- <custom-filter :fields="filterFields" @onFilter="onFilter" @onClear="onClearFilter" /> -->
    <b-card title="Commodity">
      <b-button
        class="btn-sm btn-nav-link btn-nav-link-white"
        size="sm"
        variant="flat-primary"
        :to="{ name: 'admin-commodity-register' }"
      >
        <feather-icon icon="PlusIcon" />
        Adicionar
      </b-button>
      <b-button
      class="btn-sm btn-nav-link btn-nav-link-white"
      size="sm"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="flat-primary"
      @click="reportData"
    >
      <feather-icon icon="FileTextIcon" />
      Exportar
    </b-button>
      <custom-g-table
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :hasEditButton="true"
        :hasDeleteButton="false"
        :totalRows="totalRows"
        :limit="limit"
        @changePage="onChangePage"
        @onEdit="onEdit"
        @onDelete="onDelete"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
      />
    </b-card>
  </div>
</template>

<script>
import { BButton, BCard } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import commodityService from "@/providers/commodityService";
import AppConstants from "@/appConstants";
// import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import dropdownService from '@/providers/dropdownService';
import messageDialogHelper from '@/helpers/message-dialog-helper';
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  components: {
    BCard,
    BButton,
    CustomGTable,
    // CustomFilter
  },
  data() {
    return {
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filterFields: [
        { id: 'filter-name', placeholder: 'Nome', type: 'text', inputType: 'text', model: 'name' },
        { id: 'filter-origin', placeholder: 'Origem', type: 'list', inputType: '', model: 'origin', list: 'filter-list-origin', array: [] },
      ],
      filter: {},
      tableLoading: true,
      fields: [
        { field: "id", label: "ID", sortable: false },
        { field: "labelPtBr", label: "Label PT-BR", sortable: true, filterOptions: { enabled: true, placeholder: 'Pesquisar por label pt-br', trigger: 'enter' } },
        { field: "labelEnEu", label: "Label EN-EU", sortable: true, filterOptions: { enabled: true, placeholder: 'Pesquisar por label en-eu', trigger: 'enter' } },
        { field: "labelEsEs", label: "Label ES-ES", sortable: true, filterOptions: { enabled: true, placeholder: 'Pesquisar por label es-es', trigger: 'enter' } },
        { field: "labelEsAr", label: "Label ES-AR", sortable: true, filterOptions: { enabled: true, placeholder: 'Pesquisar por label es-ar', trigger: 'enter' } },
        { field: "labelPtPt", label: "Label PT-PT", sortable: true, filterOptions: { enabled: true, placeholder: 'Pesquisar por label pt-pt', trigger: 'enter' } },
        { field: "labelZhCn", label: "Label ZH-CN", sortable: true, filterOptions: { enabled: true, placeholder: 'Pesquisar por label zh-cn', trigger: 'enter' } },
        { field: "filter", label: "Filtro", sortable: false },
        { field: "order", label: "Ordem", sortable: false, filterOptions: { enabled: true, placeholder: 'Pesquisar por ordem', trigger: 'enter' } },
        { field: "icon", label: "Icone", sortable: false },
        { field: "mne", label: "Minemonico", sortable: false },
        { field: "origins", label: "Origem", type: "object", sortable: false, filterOptions: { enabled: true, placeholder: 'Pesquisar por origem', filterDropdownItems: [] } },
        { field: "content", label: "Conteudo", type: "object", sortable: false },
        { field: "dt_create", label: "Criação", type: "custom_date", sortable: true, filterOptions: { enabled: true, placeholder: 'Pesquisar por data', trigger: 'enter' } },
        { field: "active", label: "Habilitado", type: "boolean", sortable: false, filterOptions: { enabled: true, placeholder: 'Pesquisar por ativo', filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] } },
        { field: "action_buttons", label: "Ações", sortable: false },
      ],
      origins: []
    };
  },
  mounted() {
    this.loadDataFilter();
    this.loadData();
  },
  computed: {
    searchParams() {
      const params = new URLSearchParams();
      params.append('page', this.page);
      params.append('limit', this.limit);
      
      if (this.filter.labelPtBr) {
        params.append("labelPtBr", this.filter.labelPtBr);
      }
      if (this.filter.labelEnEu) {
        params.append("labelEnEu", this.filter.labelEnEu);
      }
      if (this.filter.labelEsEs) {
        params.append("labelEsEs", this.filter.labelEsEs);
      }
      if (this.filter.labelEsAr) {
        params.append("labelEsAr", this.filter.labelEsAr);
      }
      if (this.filter.labelPtPt) {
        params.append("labelPtPt", this.filter.labelPtPt);
      }
      if (this.filter.labelZhCn) {
        params.append("labelZhCn", this.filter.labelZhCn);
      }
      if (this.filter.order) {
        params.append("order", this.filter.order);
      }
      if (this.filter.origins) {
        params.append("origins", this.filter.origins);
      }
      if (this.filter.dt_create) {
        params.append("dt_create", this.filter.dt_create);
      }
      if (this.filter.active) {
        params.append("active", this.filter.active);
      }
      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      commodityService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'commodity.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      this.filter = data;
      // console.log('OnFilter: ', this.filter);
      this.loadData();
    },
    onClearFilter() {
      this.filter = {};
      this.loadData();
    },
    loadDataFilter() {
      dropdownService.getAllOrigin(new URLSearchParams())
      .then(res => {
        // this.origins = res;
        // this.filterFields[this.filterFields.findIndex(item => item.id=='filter-origin')].array = this.origins;
        const origins = res.map(item => {
          return { value: item.id, text: item.name };
        });
        this.fields[this.fields.findIndex(item => item.field=='origins')].filterOptions.filterDropdownItems = origins;
      })
      .catch(err => console.log(err));
    },
    onEdit(data) {
      this.$router.push(
        `${AppConstants.NAVIGATION_PAGE_ADM_COMMODITY_REGISTER}/${data._id}`
      );
    },
    onDelete(data) {
      // console.log(data);
      const params = new URLSearchParams();
      params.append("id", data._id);
      commodityService
        .deleteCommodity(params)
        .then(() => {
          console.log("deleted");
          messageDialogHelper.displayDeleteDataMessage(()=> {
            this.loadData();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', commodityService.getAllCommodity(this.searchParams))
        .then((res) => {
          this.tableLoading = false;
          this.data = res.data;
          this.totalRows = res.totalRows;
        })
        .catch((err) => console.log(err));
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>